import {
  params, string, shape, arrayOf, bool, number
} from '@thd-nucleus/data-sources';

// 'identifiers', 'info', 'media', 'pricing', 'reviews'
const productModel = {
  itemId: string(),
  dataSources: string(),
  identifiers: shape({
    canonicalUrl: string(),
    itemId: string(),
    brandName: string(),
    productLabel: string(),
  }),
  info: shape({
    label: string()
  }),
  media: shape({
    image: shape({
      url: string()
    }).client(),
    images: arrayOf(shape({
      url: string(),
      type: string(),
      subType: string(),
      sizes: arrayOf(string())
    }))
  }),
  pricing: params({ storeId: string() }).shape({
    message: string(),
    original: number({ float: true }),
    mapAboveOriginalPrice: bool(),
    promotion: shape({
      dollarOff: number({ float: true })
    }),
    value: number({ float: true }),
  }),
  reviews: shape({
    ratingsReviews: shape({
      totalReviews: string(),
      averageRating: string()
    })
  })
};

const wrappedProduct = shape({
  category: string(),
  description: string(),
  idEndDate: string(),
  idPromoDetails: string(),
  idStartDate: string(),
  isAnchor: bool(),
  product: shape(productModel),
  slot: shape({
    description: string(),
    isRequired: bool(),
    name: string(),
  })
});

export const dataModel = {
  bundle: params({ itemId: string().isRequired() }).shape({
    metadata: shape({
      type: string()
    }),
    products: arrayOf(wrappedProduct)
  }),
  clientOnlyProduct: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    availabilityType: shape({
      discontinued: bool()
    }),
    fulfillment: params({ storeId: string() }).shape({
      fulfillmentOptions: arrayOf(shape({
        fulfillable: bool()
      }))
    })
  }),
  product: params({ itemId: string().isRequired() }).shape(productModel),
  dynamicRecs: params({ itemId: string().isRequired(), storeId: string() }).shape({
    promo: shape({
      metadata: shape({
        type: string()
      }),
      products: arrayOf(wrappedProduct)
    })
  })
};
